import {
  Component,
  OnInit,
  Injector
} from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "src/app/services/utils.service";
@Component({
  selector: "app-partner-subscription-redemption-popup-modal",
  templateUrl: "./partner-subscription-redemption-popup-modal.component.html",
  styleUrls: ["./partner-subscription-redemption-popup-modal.component.scss"],
})
export class PartnerSubscriptionRedemptionPopupModalComponent
  implements OnInit
{
  redirectionLink: string;
  authoringContentData: any;
  utilsSvc: UtilsService;
  router: Router;
  enableRedirection: boolean;
  isRegistered: boolean;
  goToButtonEnabled: boolean = false;
  isHuluSoc: boolean = false;
  isNetFlixSoc: boolean = false;
  redemptionTitleTxt: any;
  redemptionTxt: any;
  redemptionAgreeTxt: any;
  redemptionStreamingTerms: any;
  termsAndConditionUrl: any;
  redemptionBeforeUsingTxt: any;
  redemptionGotoTxt: any;
  isRegisteredTxt1: any;
  isRegisteredTxt2: any;
  isRegisteredTxt3: any;
  isRegisteredTxt4: any;
  careReminderTitleTxt: any;
  careReminderTxt: any;
  redemptionSrcImage: string;
  redemptionAltText: string;
  huluUrl: any;


  constructor(private activeModalService: NgbActiveModal, private injector : Injector) {
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this.router = this.injector.get<Router>(Router);
  }

  ngOnInit(): void {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.setCopyValues();
  }

  setCopyValues() {
    if (this.isNetFlixSoc) {
      this.redemptionTitleTxt = this.authoringContentData?.reviewChangeService?.netflixRedemptionTitleTxt;
      this.redemptionTxt = this.authoringContentData?.reviewChangeService?.netflixRedemptionTxt;
      this.redemptionAgreeTxt = this.authoringContentData?.reviewChangeService?.netflixRedemptionAgreeTxt;
      this.redemptionStreamingTerms = this.authoringContentData?.reviewChangeService?.netflixRedemptionStreamingTerms;
      this.termsAndConditionUrl = this.authoringContentData?.footer?.netflixTermsAndConditionUrl;
      this.redemptionBeforeUsingTxt = this.authoringContentData?.reviewChangeService?.netflixRedemptionBeforeUsingTxt;
      this.redemptionGotoTxt = this.authoringContentData?.reviewChangeService?.netflixRedemptionGotoTxt;
      this.isRegisteredTxt1 = this.authoringContentData?.reviewChangeService?.netflixIsRegisteredTxt1;
      this.isRegisteredTxt2 = this.authoringContentData?.reviewChangeService?.netflixIsRegisteredTxt2;
      this.isRegisteredTxt3 = this.authoringContentData?.reviewChangeService?.netflixIsRegisteredTxt3;
      this.isRegisteredTxt4 = this.authoringContentData?.reviewChangeService?.netflixIsRegisteredTxt4;
      this.careReminderTitleTxt = this.authoringContentData?.reviewChangeService?.careNetflixReminderTitleTxt;
      this.careReminderTxt = this.authoringContentData?.reviewChangeService?.careNetflixReminderTxt;
      this.redemptionSrcImage = "/assets/tfb-acctmgmt/images/netflix.svg";
      this.redemptionAltText = "Netflix Redirection";
    }
    if (this.isHuluSoc) {
      this.redemptionTitleTxt = this.authoringContentData?.reviewChangeService?.huluRedemptionTitleTxt;
      this.redemptionTxt = this.authoringContentData?.reviewChangeService?.huluRedemptionTxt;
      this.redemptionAgreeTxt = this.authoringContentData?.reviewChangeService?.huluRedemptionAgreeTxt;
      this.redemptionStreamingTerms = this.authoringContentData?.reviewChangeService?.huluRedemptionStreamingTerms;
      this.termsAndConditionUrl = this.authoringContentData?.footer?.huluTermsAndConditionUrl;
      this.redemptionBeforeUsingTxt = this.authoringContentData?.reviewChangeService?.huluRedemptionBeforeUsingTxt;
      this.redemptionGotoTxt = this.authoringContentData?.reviewChangeService?.huluRedemptionGotoTxt;
      this.isRegisteredTxt1 = this.authoringContentData?.reviewChangeService?.huluIsRegisteredTxt1;
      this.isRegisteredTxt2 = this.authoringContentData?.reviewChangeService?.huluIsRegisteredTxt2;
      this.isRegisteredTxt3 = this.authoringContentData?.reviewChangeService?.huluIsRegisteredTxt3;
      this.isRegisteredTxt4 = this.authoringContentData?.reviewChangeService?.huluIsRegisteredTxt4;
      this.careReminderTitleTxt = this.authoringContentData?.reviewChangeService?.careHuluReminderTitleTxt;
      this.careReminderTxt = this.authoringContentData?.reviewChangeService?.careHuluReminderTxt;
      this.huluUrl = this.authoringContentData?.footer?.huluUrl;
      this.redemptionSrcImage = "/assets/tfb-acctmgmt/images/hulu.svg";
      this.redemptionAltText = "HULU Redirection";
    }
  }


  close() {
    this.activeModalService.dismiss();
  }

  goToNetflix() {
    window.open(this.redirectionLink, '_blank ');
  }

  goToHulu() {
    window.open(this.huluUrl, '_blank ');
  }
  
  termsChecked(event){
    if(event.checked === true ){
      this.goToButtonEnabled = true;
    }else{
      this.goToButtonEnabled = false;
    }
  }
}
